import { USE_CASE_PAGE_PATHS } from '@/shared/constants/use-case-pages';
import { InferGetStaticPropsType } from 'next';
import React, { ReactElement } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import { Layout } from '@/components/Common';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { HeroSection } from '@/components/UseCase';
import { NextPageWithLayout } from '@/pages/_app';
import PlatformPageSection from 'src/components/Platform/PlatformPageSection';
import ExpandYourSalesAndMarketing from '@/components/Platform/ExpandYourRetailNetwork';
import { BrandVideos, Trustpilot } from '@/components/Home';
import { HOME_PAGE_BRAND_VIDEO_LIST } from '@/shared/constants/landing-pages';
import './index.less';

export async function getStaticPaths() {
  return {
    paths: Object.keys(USE_CASE_PAGE_PATHS).map((e) => `/use-case/${e}`),
    fallback: 'blocking',
  };
}

export const getStaticProps = async (context) => {
  const { params } = context;
  const { path } = params;

  if (!Object(USE_CASE_PAGE_PATHS).hasOwnProperty(String(path))) {
    return {
      notFound: true,
    };
  }

  const pageInfo = USE_CASE_PAGE_PATHS[String(path)];

  return {
    props: {
      pageInfo,
      pageName: path,
      path: `/use-case/${path}`,
      meta: pageInfo?.meta,
    },
    revalidate: 5 * 60,
  };
};
const UseCasePage: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({ pageInfo, pageName }) => {
  return (
    <div className="use-case-page-wrap">
      <HeroSection data={pageInfo.hero} customClass={pageName} />
      <div className="use-case-page-trustpilot-wrap">
        <Trustpilot />
      </div>
      <PlatformPageSection content={pageInfo.section} utmSource="use_case" />
      <BrandVideos
        className="platform-brand-video-container"
        brandTitle="300,000+ brands & entrepreneurs choose Pietra"
        brandList={HOME_PAGE_BRAND_VIDEO_LIST}
      />
      <ExpandYourSalesAndMarketing
        title={pageInfo?.footer?.title}
        description={pageInfo?.footer?.description}
        btnText={pageInfo?.footer?.buttonText}
        customStyle={pageInfo?.footer?.customStyle}
      />
    </div>
  );
};

UseCasePage.getLayout = (page: ReactElement) => {
  const { meta, path } = page.props;
  return (
    <>
      <CustomHead
        title={meta?.title}
        description={meta?.description}
        url={`${WEBSITE_URL}${path}`}
        image={`${STATIC_FILE_URL}/${meta?.image}`}
      />
      <Layout
        structured={SEO_META[SEO_META_PAGES[meta?.key]].jsonld({
          url: typeof window === 'object' ? window.location.href : '',
        })}
      >
        {page}
      </Layout>
    </>
  );
};
export default UseCasePage;
